import '@sistemiv/s-components/dist/TC.css'
import { MsalProvider } from '@azure/msal-react'
import React, { FC } from 'react'
import AppRouter from './router/AppRouter'
import { Toaster } from 'react-hot-toast'

const App: FC<{ pca: any }> = ({ pca }) => {
  return (
    <MsalProvider instance={pca}>
      <AppRouter />
      <Toaster position='bottom-right' reverseOrder={false} />
    </MsalProvider>
  )
}

export default App
